<template>
  <div>
    <GrantStat />
  </div>
</template>

<script>
import GrantStat from '@/views/config/spins-consume/compents/grant-stat.vue'

export default {
  name: 'Index',
  components: {
    GrantStat
  }
}
</script>

<style scoped>

</style>
